import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { ChakraProvider } from '@chakra-ui/react';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { SessionProvider } from './utils/SessionContext';
import '@fontsource/poppins';
import '@fontsource/space-grotesk';

// Suppress the aria-hidden warning
const originalWarn = console.warn;
console.warn = (...args) => {
  if (args[0].includes('Blocked aria-hidden on an element because its descendant retained focus')) {
    return;
  }
  originalWarn(...args);
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ChakraProvider>
      <BrowserRouter>
        <SessionProvider>
          <App />
        </SessionProvider>
      </BrowserRouter>
    </ChakraProvider>
  </React.StrictMode>
);